import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import azureDevOpsPlugin from '@backstage-community/plugin-azure-devops/alpha';
import sonarQubePlugin from '@backstage-community/plugin-sonarqube/alpha';
import { navModule } from './modules/nav';
import { azureModule } from './modules/azure';
import { microsoftAuthApiRef } from '@backstage/core-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import { createFrontendModule } from '@backstage/frontend-plugin-api';

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props =>
      (
        <SignInPage
          {...props}
          auto
          provider={{
            id: 'microsoft-auth-provider',
            title: 'Microsoft Entra ID',
            message: 'Entre com sua conta corporativa',
            apiRef: microsoftAuthApiRef,
          }}
        />
      ),
  },
});

export default createApp({
  features: [
    catalogPlugin,
    // Abas Pipelines, Pull Requests e Git Tags na página da entidade
    azureDevOpsPlugin,
    // Aba SonarQube e card de qualidade de código
    sonarQubePlugin,
    navModule,
    azureModule,
    createFrontendModule({
      pluginId: 'app',
      extensions: [signInPage],
    }),
  ],
});
